import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-placeholders-3',
  templateUrl: './3.component.html',
  styleUrls: ['./3.component.scss'],
})
export class VbPlaceholders3Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
